import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import { checkCompanyDetails, checkAddressSensitive, validarorTips } from '@/shared/utils/validator';
import { InfoComplementField } from '../../types';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'CompanyAddressDetails' })
export default class CompanyAddressDetails
  extends Vue
  implements InfoComplementField {
  @Prop()
  private value!: string;

  /** 校验器  调用onValidator方法时会优先调用传入的校验器
   * (value, setErrorMsg) => boolean; value为当前输入框输入的值 setErrorMsg是一个设置校验错误信息的函数
  */
  @Prop()
  private validator: ((value: string, setErrorMsg: (msg: string) => void) => boolean) | undefined;

  private companyAddressDetails = '';

  private errorMsg = '';

  private setErrorMsg(msg: string) {
    this.errorMsg = msg;
  }

  public onValidator(): boolean {
    const val = this.companyAddressDetails;
    if (typeof this.validator === 'function') {
      return this.validator(val, this.setErrorMsg.bind(this));
    }
    if (!checkAddressSensitive(val)) {
      this.errorMsg = validarorTips.addressSensitiveTip;
      return false;
    }
    if (!checkCompanyDetails(val)) {
      this.errorMsg = validarorTips.addressLengthTip;
      return false;
    }
    return true;
  }

  private created() {
    if (this.value) {
      this.companyAddressDetails = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: string) {
    if (val !== this.companyAddressDetails) {
      this.companyAddressDetails = val;
    }
  }

  // 清空校验
  private onChangeDetails(val: string) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private onBlur() {
    this.$emit('blur');
  }

  private render() {
    return (
      <div class={style.CompanyAddressDetails}>
        <Field
          v-model={this.companyAddressDetails}
          type="text"
          sub={true}
          label={'详细地址'}
          placeholder={'填写详细地址（不少于5个字）'}
          onChange={this.onChangeDetails.bind(this)}
          error={this.errorMsg}
          onBlur={this.onBlur.bind(this)}
        />
      </div>
    );
  }
}
